const config = {
  baseUrl: 'https://uat-mobile.bangkokdrugstore.co.th',
  apmServiceName: 'medlink-uat',
  env: 'uat'
};
export default config;
